module.exports = __webpack_public_path__ + "4dc5783e66f49cb582c61e598fbc00f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/loop-button.png
// module id = 46
// module chunks = 0